import { render, staticRenderFns } from "./BoxLocalOcorrencia.vue?vue&type=template&id=6f6d3ef7&"
import script from "./BoxLocalOcorrencia.vue?vue&type=script&lang=js&"
export * from "./BoxLocalOcorrencia.vue?vue&type=script&lang=js&"
import style0 from "./BoxLocalOcorrencia.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports